import React from 'react';
import { RouteComponentProps } from 'react-router';

import DashboardLayout from './DashboardLayout';
import Helmet from 'react-helmet';
import { startCase } from 'lodash';

const withDashboard = <P extends object>(Component: React.ComponentType<P>) => {
  type Props = P & RouteComponentProps<{ companyId?: string }>;

  class WithDashboard extends React.Component<Props> {
    render() {
      return (
        <DashboardLayout>
          <Helmet>
            <title>{startCase(this.props.location.pathname)}</title>
          </Helmet>
          <Component {...this.props} />
        </DashboardLayout>
      );
    }
  }

  return WithDashboard;
};
export default withDashboard;
